export default "__VITE_ASSET__DG7EFD9x__"